// Returns the element that actually scrolls on the Task Details page.
// The task content normally lives inside `.task-details-wrapper`
// (overflow-y: auto), but depending on layout/zoom the document itself may be
// the scroller. We return whichever element can actually scroll so the scroll
// position can be captured and restored consistently from either component.
export const getTaskDetailsScroller = () => {
  const wrapper = document.querySelector('.task-details-wrapper');
  if (wrapper && wrapper.scrollHeight - wrapper.clientHeight > 1) {
    return wrapper;
  }
  const scrollingEl = document.scrollingElement || document.documentElement;
  if (scrollingEl && scrollingEl.scrollHeight - scrollingEl.clientHeight > 1) {
    return scrollingEl;
  }
  // Fall back to the wrapper (preferred) even if not currently scrollable.
  return wrapper || scrollingEl || null;
};
